<template>
  <form @submit.prevent="save">
    <close-button @click="$emit('close')" class="close-button"></close-button>

    <div class="dialog-header">
      <h1>Beschrijving wijzigen</h1>
    </div>
    <div class="dialog-content">
      <div class="field-wrapper">
        <div class="field-100 label-fix">
          <label for="description">Beschrijving</label>
          <div>
            <textarea
              id="description"
              ref="description"
              type="text"
              v-model="description"
              name="description"
              :readonly="empty"
              :class="{ empty: empty }"
              placeholder="Typ hier een nieuwe beschrijving voor de geselecteerde ontwerpen"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="empty-toggle">
        <select-box :selected="empty" @action="toggleEmpty"></select-box>
        <span class="pointer" @click="toggleEmpty()">Geen beschrijving </span>
      </div>
      <div class="button-holder">
        <button
          id="confirm-button"
          class="pill-button"
          type="submit"
          :disabled="!empty && !description"
        >
          Wijzigen
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { updateProduct } from '@/features/printstore/PrintStoreApi'


export default {
  name: 'EditMultipleDescriptions',
  props: ['productIds', 'callback'],
  data() {
    return {
      description: '',
      empty: false,
      dirty: false
    }
  },
  mounted() {
    this.$refs.description.focus()
  },
  methods: {
    toggleEmpty() {
      this.empty = !this.empty
    },
    save() {
      this.productIds.forEach(async (id) => {
        await updateProduct({
          id: id,
          description: this.empty ? '' : this.description
        })
      })
      this.callback()
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
label {
  width: 73px;
}

.field-wrapper {
  margin-bottom: 20px;
}

textarea {
  width: 100%;
  height: 100px;

  &.empty {
    opacity: 0.4;
  }
}

.empty-toggle {
  margin-bottom: 24px;
}
</style>
